import React, { useContext, useEffect, useRef, useState } from "react";
import "./styles.css";
import { Button } from "../Button";
import { CustomSelect } from "../CustomSelect";
import { CustonInput } from "../CustonInput";
import { quoteContext } from "../../context/quotesContext";
import homeIcon from "../../../public/assets/icon/homeIcon.svg";
import addIcon from "../../../public/assets/icon/addIcon.png";
import { formatPhoneNumber } from "../../utils";
import { SummarOrderMobile } from "../SummarOrderMobile";
import { useTranslation } from "react-i18next";
import rule from "../../../public/assets/iconRule.svg";
import paid from "../../../public/assets/icon/Paid.svg";

const AddressFrom = ({
  selectedAddress,
  returnStep,
  citiesOptions,
  canContinue,
  addressOptions,
  onClickContinue,
  isColAdress = false,
  createAdress,
  onSelectAddressOption,
}) => {
  const [t, i18n] = useTranslation();
  const {
    stateOption,
    fromZipCode,
    setFromZipCode,
    cityNewAddress,
    setCityNewAddress,
    neighborhoodNewAdress,
    setNeighborhoodNewAdress,
    addressNewAdress,
    setAddressNewAdress,
    indicationsNewAdress,
    setIidicationsNewAddress,
    namesNewAdress,
    setNamesNewAdress,
    phoneNewAdress,
    setPhoneNewAdress,
    loading,
    emailNewAdress,
    setEmailNewAdress,
    setIsColAdress,
    isValidNewAddress,
    cityOptionSelected,
    isEmailValid,
    isPhoneValid,
    isNameValid,
    isAddressValid,
    isNeighborhoodNewAdress,
    isIndicationsValid,
    dimensions,
    dimensionsType,
    weightType,
    value,
    weight,
    setCurrentStep,
    createShipmentResponse,
    selectedProvider,
    setSelectedProvider,
    setCurrentSubStep,
    currentSubStep
  } = useContext(quoteContext);
  const [addAddressFormOpen, setAddAddressFormOpen] = useState(false);
  const [selectedAddressZip, setSelectedAddressZip] = useState('');
  const autocompleteContainerRef = useRef(null);
  const autocompleteElementRef = useRef(null);
  const googleMapsScriptLoadingRef = useRef(false);
  const googleMapsLoadedRef = useRef(false);
  
  const loadGoogleMapsScript = () => {
    if (typeof window !== 'undefined' && window.google && window.google.maps && window.google.maps.places) {
      googleMapsLoadedRef.current = true;
      console.log('[Places] google maps already loaded');
      return Promise.resolve();
    }
    if (googleMapsScriptLoadingRef.current) {
      console.log('[Places] waiting for existing google maps script load');
      return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (window.google && window.google.maps) {
            clearInterval(checkInterval);
            googleMapsLoadedRef.current = true;
            resolve();
          }
        }, 100);
      });
    }
    googleMapsScriptLoadingRef.current = true;
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
      if (!apiKey) {
        console.warn('[Places] Missing REACT_APP_GOOGLE_MAPS_API_KEY');
      }
      // Bias responses and UI to US region
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly&loading=async&region=US`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        googleMapsLoadedRef.current = true;
        console.log('[Places] google maps script loaded');
        resolve();
      };
      script.onerror = () => reject(new Error('Failed to load Google Maps script'));
      document.head.appendChild(script);
    });
  };

  const initPlacesAutocomplete = async () => {
    if (!autocompleteContainerRef.current) return;
    console.log('[Places] initPlacesAutocomplete start');
    await loadGoogleMapsScript();
    if (!window.google || !window.google.maps) return;
    try {
      // Ensure the Places library and web component are loaded
      // @ts-ignore
      await window.google.maps.importLibrary('places');
      if (typeof window.customElements?.whenDefined === 'function') {
        try {
          await window.customElements.whenDefined('gmp-place-autocomplete');
        } catch (e) {}
      }
      console.log('[Places] libraries available, creating PlaceAutocompleteElement');
    } catch (e) {
      console.error('[Places] error importing places library:', e);
      return;
    }

    // Cleanup previous element if exists
    if (autocompleteElementRef.current) {
      try {
        autocompleteElementRef.current.remove();
      } catch (e) {}
      autocompleteElementRef.current = null;
    }

    // Create the Place Autocomplete Web Component
    // @ts-ignore
    const placeAutocomplete = new window.google.maps.places.PlaceAutocompleteElement();
    // Force light appearance regardless of OS theme
    try {
      placeAutocomplete.style.setProperty('color-scheme', 'light');
      // placeAutocomplete.style.setProperty('background', '#ffffff');
      // placeAutocomplete.style.setProperty('color', '#111111');
      // placeAutocomplete.style.setProperty('border', '1px solid #ddd');
      // placeAutocomplete.style.setProperty('border-radius', '4px');
      // placeAutocomplete.style.setProperty('padding', '6px 8px');
      // placeAutocomplete.style.setProperty('display', 'block');
      // placeAutocomplete.style.setProperty('width', '100%');
      // Common tokens used by Google components (best-effort; ignored if unsupported)
      // placeAutocomplete.style.setProperty('--gmpx-color-surface', '#ffffff');
      // placeAutocomplete.style.setProperty('--gmpx-color-on-surface', '#111111');
      // placeAutocomplete.style.setProperty('--gmpx-color-outline', '#dddddd');
    } catch (e) {}
    // @ts-ignore
    placeAutocomplete.id = 'place-autocomplete-input';
    // Optional: bias to USA remitente use case
    try {
      // @ts-ignore - some builds expose this as country property
      placeAutocomplete.country = ["us"];
    } catch (e) {}

    // Insert into container
    autocompleteContainerRef.current.innerHTML = '';
    // @ts-ignore
    autocompleteContainerRef.current.appendChild(placeAutocomplete);
    console.log('[Places] PlaceAutocompleteElement appended');

    // Listen for selection and update address state only on valid selection
    const handler = async (evt) => {
      try {
        console.log('[Places] selection event fired:', evt.type, evt);
        const { placePrediction } = evt;
        const place = placePrediction.toPlace();
        // Request only valid fields for the new Places library (no legacy names)
        await place.fetchFields({ fields: ['displayName', 'formattedAddress', 'addressComponents'] });
        console.log('[Places] fetched place fields:', {
          displayName: place.displayName,
          formattedAddress: place.formattedAddress,
          formattedAddressLength: place.formattedAddress ? place.formattedAddress.length : null,
        });
        // Try to extract the postal code and city from address components
        let postalCode = '';
        let selectedCity = '';
        try {
          const rawComponents = place.addressComponents;
          const componentsArray = Array.isArray(rawComponents) ? rawComponents : [];
          if (Array.isArray(componentsArray)) {
            // Extract postal code
            const postalComp = componentsArray.find((comp) => {
              const types = comp?.types || comp?.type || [];
              return Array.isArray(types) ? types.includes('postal_code') : types === 'postal_code';
            });
            if (postalComp) {
              postalCode = postalComp.shortText || postalComp.longText || postalComp.short_name || postalComp.long_name || '';
            }

            // Extract city (try multiple component types)
            const cityComp = componentsArray.find((comp) => {
              const types = comp?.types || comp?.type || [];
              return Array.isArray(types) && (
                types.includes('locality') ||
                types.includes('administrative_area_level_2') ||
                types.includes('administrative_area_level_1')
              );
            });
            if (cityComp) {
              selectedCity = cityComp.longText || cityComp.long_name || cityComp.shortText || cityComp.short_name || '';
            }
          }
        } catch (e) {
          console.warn('[Places] unable to parse addressComponents');
        }
        if (postalCode) {
          setSelectedAddressZip(postalCode);
        }

        // Auto-select city from citiesOptions if found
        if (selectedCity && citiesOptions && citiesOptions.length > 0) {
          const matchingCity = citiesOptions.find(city =>
            city.city && selectedCity &&
            city.city.toLowerCase().includes(selectedCity.toLowerCase())
          );
          if (matchingCity) {
            setCityNewAddress(matchingCity);
            console.log('[Places] Auto-selected city:', matchingCity.city);
          } else {
            console.log('[Places] City not found in options:', selectedCity);
          }
        }
        const computedAddressValid = !!(place.displayName && place.displayName.length <= 100);
        console.log('[Places] pre-set validations snapshot:', {
          nameValid: typeof isNameValid === 'function' ? isNameValid() : undefined,
          phoneValid: typeof isPhoneValid === 'function' ? isPhoneValid() : undefined,
          citySelected: !!cityNewAddress,
          addressValidFromSelected: computedAddressValid,
          isValidNewAddressCurrent: isValidNewAddress,
        });
        if (place.displayName) {
          setAddressNewAdress(place.displayName);
          setTimeout(() => {
            console.log('[Places] post-set address snapshot (async):', {
              displayName: place.displayName,
              formattedAddress: place.formattedAddress,
              note: 'Using displayName for clean street address, city/state/zip handled separately.',
            });
          }, 0);
        }
        // Reflect ZIP in the visible input value without altering saved address
        try {
          if (postalCode && autocompleteElementRef.current) {
            const formattedWithZip = `${place.formattedAddress} (${postalCode})`;
            // @ts-ignore
            if (typeof autocompleteElementRef.current.value !== 'undefined') {
              // @ts-ignore
              autocompleteElementRef.current.value = formattedWithZip;
            } else {
              autocompleteElementRef.current.setAttribute('value', formattedWithZip);
            }
          }
        } catch (e) {}
      } catch (e) {
        console.error('[Places] error handling selection event:', e);
      }
    };
    // Attach both names for broader compatibility
    // @ts-ignore
    placeAutocomplete.addEventListener('gmp-select', handler);
    // @ts-ignore
    placeAutocomplete.addEventListener('gmp-placeselect', handler);

    autocompleteElementRef.current = placeAutocomplete;
  };
  
  const handleCreateAddress = () => {
    createAdress();
    setAddAddressFormOpen(false);
  };

  const zipCodesMatch = selectedAddressZip && fromZipCode && selectedAddressZip.trim() === fromZipCode.trim();

  useEffect(()=>setIsColAdress(isColAdress),[]);

  // Initialize Google Places Autocomplete when opening the USA address form
  useEffect(() => {
    if (addAddressFormOpen && !isColAdress) {
      initPlacesAutocomplete();
    }
    return () => {
      if (autocompleteElementRef.current) {
        try {
          autocompleteElementRef.current.remove();
        } catch (e) {}
        autocompleteElementRef.current = null;
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addAddressFormOpen, isColAdress]);
  const dimensionsTypeText = () => {
    return dimensionsType.id === 1 ? "cm" : "inc";
  };

  const weightTypeText = () => {
    return weightType.id === 1 ? "Lb" : "Kg";
  };
  return (

      <div className="address-container">
        {currentSubStep === 1 && (<h3>{t("delivery_summary")}</h3>)}

        <div className="first-step-container-resume">

          {
              !isColAdress &&
              <div className="content-resume">
            <div className="item">
              <img src={rule}/>
              <span className="label">{t('large')}</span>
              <span className="value">
              {dimensions.long} {dimensionsTypeText()}
            </span>
            </div>
            <div className="item">
              <img src={rule}/>
              <span className="label">{t('high')}</span>
              <span className="value">
              {dimensions.height} {dimensionsTypeText()}
            </span>
            </div>
            <div className="item">
              <img src={rule}/>
              <span className="label"> {t('width')}</span>
              <span className="value">
              {dimensions.broad} {dimensionsTypeText()}
            </span>
            </div>
            <div className="item">
              <img src={rule}/>
              <span className="label">{t('weight')}</span>
              <span className="value">
              {weight} {weightTypeText()}
            </span>
            </div>
            <div className="item">
              <img src={paid}/>
              <span className="label">{t('declared_value')}</span>
              <span className="value">{value} USD</span>
            </div>
          </div>
          }

          <a onClick={() => setCurrentStep(1)} className="link-blue">
            {t('edit_measures')}
          </a>
        </div>

        {currentSubStep === 1 && (<h3>{t("remitent_data")}</h3>)}

        {addAddressFormOpen && (
            <div className="address-item form">

              <label>
                <div className="address-header">
                  <div className="icon">
                    <img src={homeIcon}/>
                  </div>
                  <div className="addressName">
                    {
                        !isColAdress && <>
                          <span>{stateOption.state}</span>
                          <span className={selectedAddressZip && !zipCodesMatch ? 'zip-highlight-error' : ''}>
                            {fromZipCode}
                          </span>
                        </>
                    }
                    {
                        isColAdress && <>
                          <span>{cityOptionSelected.city}</span>
                        </>
                    }
                  </div>
                </div>
                <div className="address-details">
                  <input
                      value={namesNewAdress}
                      onChange={(data) => setNamesNewAdress(data.target.value)}
                      type="text"
                      required
                      autoComplete="off"
                      placeholder={
                        isColAdress
                            ? t('destination_name')
                            : t('remitent_name')
                      }
                  />
                  {!isColAdress && (
                    <>
                    <span>Elige tu dirección tal cual aparece en google maps</span>
                    {selectedAddressZip && (
                      <div className={`zip-match-indicator ${zipCodesMatch ? 'match' : 'no-match'}`}>
                        {zipCodesMatch
                          ? `✓ Los códigos postales coinciden`
                          : `✗ Los códigos postales no coinciden: tú seleccionaste en el inicio ${fromZipCode} pero la dirección seleccionada tiene ${selectedAddressZip}`
                        }
                      </div>
                    )}
                    <div className="address-autocomplete" ref={autocompleteContainerRef} />
                    </>
                  )}
                  {!isColAdress && (
                      <CustonInput
                          placeholder={t('city')}
                          showError={false}
                          className="address-from"
                          options={citiesOptions}
                          value={cityNewAddress && cityNewAddress.city}
                          onSelectOption={setCityNewAddress}
                          autoOpenOnFocus={true}
                      />
                  )}
                  <div className="phone-address">
                    <input
                        value={phoneNewAdress}
                        type="text"
                        required
                        autoComplete="off"
                        onChange={(data) => setPhoneNewAdress(data.target.value)}
                        placeholder={t('phone_number')}
                    />
                    {isColAdress && (
                      <input
                          value={addressNewAdress}
                          onChange={(data) => setAddressNewAdress(data.target.value)}
                          type="text"
                          required
                          autoComplete="off"
                          placeholder={t('address')}
                      />
                    )}
                  </div>
                  {isColAdress && (
                      <input
                          value={neighborhoodNewAdress}
                          onChange={(data) =>
                              setNeighborhoodNewAdress(data.target.value)
                          }
                          type="text"
                          required
                          autoComplete="off"
                          placeholder={t('neighborhood')}
                      />
                  )}
                  {isColAdress && <input
                      value={emailNewAdress}
                      onChange={(data) =>
                          setEmailNewAdress(data.target.value)
                      }
                      type="text"
                      required
                      autoComplete="off"
                      placeholder={t('Email')}
                  />}
                  <textarea
                      autoComplete="off"
                      value={indicationsNewAdress}
                      onChange={(data) => setIidicationsNewAddress(data.target.value)}
                      placeholder={t('Indications')}
                  ></textarea>

                  <div className="phone-address">
                    <Button onClick={() => {
                      setAddAddressFormOpen(false);
                      setSelectedAddressZip('');
                    }} className="save-cancel-btn">
                      {"Close"}
                    </Button>
                    <Button disable={!isValidNewAddress || (!isColAdress && !zipCodesMatch)} onClick={handleCreateAddress} className="save-btn">
                      {loading ? "Loading..." : (isColAdress ? "Guardar dirección Colombia" : "Guardar dirección USA")}
                    </Button>
                  </div>
                </div>
              </label>
            </div>
        )}
        <div className="address-items-container">
          {addressOptions.length > 0 &&
              addressOptions.map((address) => (
                  <div key={address.id} className="address-item">
                    <label htmlFor="medellin">
                      <div className="address-header">
                        <input
                            type="radio"
                            id={address.id}
                            className="address-input"
                            name="address"
                            checked={selectedAddress === address.id}
                            onChange={() => onSelectAddressOption(address.id)}
                        />
                        <div className="icon">
                          <img src={homeIcon}/>
                        </div>

                        <span></span>
                      </div>
                      <div>
                        <div className="addressName">
                    <span>
                      {address.address && (
                          <>
                            {address.address}
                            <br/>
                          </>
                      )}
                      {address.street && (
                          <>
                            {address.street}
                            <br/>
                          </>
                      )}
                    </span>
                        </div>
                        <div className="address-info">
                          {(address.ccity && address.state) && (
                              <>
                                {address.ccity},{' '}
                                {address.state}
                                {address.zip && `, ${address.zip}`}
                                <br/>
                              </>
                          )}
                          {(address.city && address.state && typeof address.city === 'string') && (
                              <>
                                {address.city},{' '}
                                {address.state}
                                {address.zip && `, ${address.zip}`}
                                <br/>
                              </>
                          )}

                          {address.country && (
                              <>
                                {address.country}
                                <br/>
                              </>
                          )}

                          {(address.telefonoRecibe) && (
                              <>
                                {address.nombreRecibe && address.nombreRecibe + ', '}
                                {formatPhoneNumber(address.telefonoRecibe)}
                                <br/>
                              </>
                          )}
                          {(address.phone) && (
                              <>
                                {address.sender_name && address.sender_name + ', '}
                                {formatPhoneNumber(address.phone)}
                                <br/>
                              </>
                          )}
                        </div>
                      </div>
                    </label>
                  </div>
              ))}
        </div>
        <div className="col-details-mobile">
          <SummarOrderMobile></SummarOrderMobile>
        </div>
        <div className="actions-container">
          {currentSubStep !== 1 && (
          <a onClick={returnStep} className="blueLink">
            {t('return')}
          </a>)}
          <a onClick={() => {
            setAddAddressFormOpen(true);
            setSelectedAddressZip('');
          }} className={`blueLink buzz`}>
            <img src={addIcon}/>
            {isColAdress ? 'Agregar dirección Colombia' : 'Agregar dirección USA'}
          </a>
          <Button disable={!canContinue || loading} onClick={onClickContinue}>
            {loading ? t('loading') : t('continue')}
          </Button>
        </div>
      </div>
  );
};

export {AddressFrom};
